import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import {
  SetEventTestClockRequestDto,
  SetEventTestClockResponseDto,
} from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

interface SetEventTestClockParams extends SetEventTestClockRequestDto {
  eventId: number;
}

const setEventTestClock = async ({
  eventId,
  stage,
}: SetEventTestClockParams): Promise<SetEventTestClockResponseDto> => {
  const response = await apiFetch(`api/admin/events/${eventId}/test-clock`, {
    method: "PATCH",
    body: JSON.stringify({ stage }),
  });

  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response));
  }

  return response.json();
};

export const useSetEventTestClock = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setEventTestClock,
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["events"] }),
  });
};
